/* eslint-disable */

import React, { useEffect, useState } from "react";

import {
  fetchAdvertisementUpload,
  fetchGraphQL,
} from "../../../services/api-raindrop.js";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropInputFile from "../../../ui-components/raindrop-input-file/raindrop-input-file.tsx";
import RaindropAdvertisement from "../../../ui-components/raindrop-advertisement/raindrop-advertisement.tsx";

import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element.js";
import { Size } from "../../../logic/enums.ts";

const AdvertisementEdit = ({
  organisationId,
  organisationName,
  organisationSrc,
  advertisementSrc,
  advertisementId,
}) => {
  const [isDeleted, setIsDeleted] = useState(false);

  const onDelete = () => {
    fetchGraphQL(`
      mutation {
        advertisementDelete (
          advertisementId: "${advertisementId}",
        ) {
          id
        }
      }
    `).then((response) => {
      if (response.errors) {
        console.error(response.errors);
        return;
      }
      setIsDeleted(true);
    });
  };

  if (isDeleted) {
    return null;
  }

  return (
    <div className="flex flex-col w-full gap-2">
      <RaindropAdvertisement
        organisationId={organisationId}
        organisationName={organisationName}
        organisationSrc={organisationSrc}
        advertisementSrc={advertisementSrc}
      />

      <div className="flex flex-row justify-end gap-4 w-full">
        <RaindropButton
          title={"Trash"}
          icon="fa-trash"
          size={Size.Large}
          isDangerous={true}
          style={ButtonStyle.Secondary}
          onClick={onDelete}
        />
      </div>
    </div>
  );
};

const AdvertisementList = ({ advertisements }) => {
  if (!advertisements) {
    return <RaindropLoadingElement />;
  }

  return (
    <div className="flex flex-col gap-12 max-w-lg">
      {advertisements.map((advertisement) => (
        <AdvertisementEdit
          organisationId={advertisement.organisation.id}
          organisationName={advertisement.organisation.name}
          organisationSrc={advertisement.organisation.presignedUrlLogo}
          advertisementSrc={advertisement.media?.presignedUrl}
          advertisementId={advertisement.id}
        />
      ))}
    </div>
  );
};

const CirrusAdvertisements = ({ organisation, currentOrganisationUser }) => {
  const [advertisements, setAdvertisements] = useState(null);

  useEffect(() => {
    fetchGraphQL(`
      query {
        advertisementObjects {
          id
          organisation {
            id
            name
            presignedUrlLogo
          }
          media {
            id
            presignedUrl
          }
        }
      }
    `).then((response) => {
      setAdvertisements(response.data.advertisementObjects);
    });
  }, []);

  return (
    <div className="flex flex-col gap-4 w-full">
      <h1 className="font-bold text-3xl">Advertisements</h1>

      <RaindropButton
        title={"Create Advertisement"}
        size={Size.Large}
        to={"/cirrus/advertisement/create"}
      />

      <AdvertisementList advertisements={advertisements} />
    </div>
  );
};

export default CirrusAdvertisements;
